// pages/purchase-orders/loader.js
export async function show({ params }) {
  const { id } = params
  const base = (process.env.REACT_APP_INVENTORY_API_URL || "").replace(/\/$/, "")
  const res = await fetch(`${base}/goods-receipts/${id}`, {
    headers: { "Content-Type": "application/json" },
    // kalau pakai cookie auth cross-domain:
  })

  const json = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw new Response(json?.message || "Failed to load PO", { status: res.status })
  }
  return json // nanti useLoaderData() dapat ini
}
